<template>
  <!-- <a-timeline class="logs" v-if="logs.length > 0" style="margin-left:20px">
    <a-timeline-item v-for="(log, index) in logs" :key="index">
      <div class="item">
        <div class="val">{{log.event}}</div>
        <div class="val">{{log.time}}</div>
        <div class="val">{{log.address}}</div>
        <div class="val">{{log.optName}}</div>
        <div class="val">{{log.description}}</div>
      </div>
    </a-timeline-item>
  </a-timeline> -->
  <div class="logs">
    <a-spin :spinning="isLoading">
      <a-table size="small" :pagination="pagination" :columns="columns" :dataSource="logs" :bordered="false" @change="pageChange"  />
    </a-spin>
  </div>
  
  <!-- <span v-else>无数据</span> -->
</template>
<script>
import moment from 'moment'
import config from '../../../config/'
import {getLocalPosition} from '../../../utils/getLocalPosition'
import { transToBD09 } from '../../../utils/globalFunction'
export default {
  props: {
    entityId: {
      required: true,
    }
  },
  data () {
    return {
      logs: [],
      pagination: {
        pageSize: 4,
        current: 1,
        showQuickJumper: false,
        size: 'small',
        total : 0,
      },
      entityLogs: [],
      isLoading: false
    }
  },
  computed: {
    columns () {
      return [
        {
          title: this.$t('global.event'),
          dataIndex: 'event',
          // width: 100,
        },
        {
          title: this.$t('global.time'),
          dataIndex: 'time',
          // width: 150,
        },
        {
          title: this.$t('global.location'),
          dataIndex: 'address',
          // width: 250,
        },
        {
          title: this.$t('global.operator'),
          dataIndex: 'optName',
          // width: 100,
        },
        {
          title: this.$t('global.description'),
          dataIndex: 'description',
          // width: 150,
        },
      ]
    }
  },
  methods: {
    moment,
    getLocalPosition,
    pageChange (page) {
      let param = {
        pageSize: 4,
        currentPage: page.current,
        orderBy: 'id',
        sort: 'ASC'
      }
      this.getSummaryLogs(param)
    },
    formatTime (timeStamp, onlyDay=false) {
      if (onlyDay) {
        return moment(timeStamp * 1000).format('YYYY-MM-DD')
      } else {
        return moment(timeStamp * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    async getAddress (point) {
      let addr = await this.getLocalPosition(point).then((address) => {
        // console.log(address)
        // addr = address
        return address
      })
      // console.log(addr)
      return addr
      // console.log(this.getLocalPosition(point).then())
      // return this.getLocalPosition(point)
    },
    formatLogs () {
      this.logs = []
      this.entityLogs.forEach((log, index) => {
        // console.log(log)
        let point = transToBD09(log.coordType, log.lng, log.lat)
        this.getLocalPosition(new BMap.Point(point.lng, point.lat)).then((address) => {
          // console.log(address)
          let time = this.formatTime(log.timestamp)
          // this.logs[index] 
          let mergeLog = {
            event: log.title,
            time,
            address: address || this.$t('home.noPosition'),
            optName: log.optName,
            description: log.description,
            index
          }
          this.logs.push(mergeLog)
          // return address
          if (this.logs.length === this.entityLogs.length) {
            // 最新事件在前 倒序
            this.logs.sort((a, b) => a.index - b.index)
          }
          this.isLoading = false
        })
      })
      // this.logs = [...this.logs]
    },
    // 获取logs
    getSummaryLogs (param) {
      this.isLoading = true
      let searchParam = Object.assign({entityId: this.entityId,}, param)
      this.$http.post(config.api.query_entity_logs_summary, searchParam).then((res) => {
        // console.log(res)
        let {code, result, desc} = res
        if (code === 0) {
          this.entityLogs = result.resultList
          this.pagination.total = result.page.totalSize
          this.pagination.current = result.page.currentPage
          this.formatLogs()
        } else {
          this.$notification.error({
            message: desc
          })
          this.isLoading = false
        }
      })
    }
  },
  mounted () {
    // this.formatLogs()
  },
  created () {
    let param = {
      pageSize: 4,
      currentPage: 1,
      orderBy: 'id',
      sort: 'ASC'
    }
    this.getSummaryLogs(param)
    // this.formatLogs()
    // console.log(this.logs)
  }
}
</script>
<style lang="less" scoped>
.logs {
  // position: relative;
  padding: 0 10px;
  // margin-left: 20px;
  // max-height: 300px;
  overflow-y: auto;
  .item {
    display: flex;
    // grid-template-columns: repeat(6, auto);
    .val {
      margin: 0 10px;
    }
  }
}
</style>